import {
	SignDocument,
	SignDocumentAnswer,
	SignDocumentRequest,
} from '@/interfaces';

const parseAnswers = (
	responses: SignDocument['responses']
): SignDocumentAnswer[] | undefined => {
	if (!responses) return undefined;
	try {
		const parsed: unknown = JSON.parse(responses);
		if (!Array.isArray(parsed)) return undefined;
		return parsed.map((answer) => ({
			id: String(answer?.id ?? ''),
			response: String(answer?.response ?? ''),
		}));
	} catch {
		return undefined;
	}
};

export const formatSignDocumentPayload = (
	body: SignDocument,
	documentUrl?: string
): SignDocumentRequest => {
	const responses = parseAnswers(body.responses);
	return {
		application_id: Number(body.application_id),
		action_id: Number(body.action_id),
		...(body.signature ? { signature: body.signature } : {}),
		...(body.firstName ? { firstname: body.firstName } : {}),
		...(body.lastName ? { lastname: body.lastName } : {}),
		status: String(body.status) === 'true',
		ip: body.ip ?? '',
		device: body.device ?? '',
		browser: body.browser ?? '',
		country: body.country ?? '',
		...(responses && { responses }),
		...(documentUrl && { document_url: documentUrl }),
	};
};
